window.onload = function() {
  $(".slider-wrap")
    .on("init", function () {
      $('.slick-slide[data-slick-index="0"]').addClass("slick-animation");
      // toggleOpacity();
    })
    .slick({
      // 現在のコードと同じオプション
      autoplay: true,
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      speed: 2000,
      autoplaySpeed: 5000,
      pauseOnFocus: false,
      pauseOnHover: false,
    })
    .on({
      // スライドが移動する前に発生するイベント
      beforeChange: function (event, slick, currentSlide, nextSlide) {
        // 表示されているスライドに.slick-animationのクラスをつける
        $(".slick-slide", this).eq(nextSlide).addClass("slick-animation");
        // あとで、.slick-animationのクラスを消すための.stop-animationクラスを付ける
        $(".slick-slide", this).eq(currentSlide).addClass("stop-animation");
      },
      // スライドが移動した後に発生するイベント
      afterChange: function () {
        // 見えてないスライドにはアニメーションのクラスを外す
        $(".stop-animation", this).removeClass("stop-animation slick-animation");
      },
    });
  
    // function toggleOpacity() {
    //   // ランダムな時間間隔でopacityを0.9から1まで連続的に変化させるアニメーションを実行
    //   var randomInterval = Math.floor(Math.random() * 45) + 5; // 500～2000ミリ秒のランダムな間隔
    //   $(".slider-item-overlay").animate(
    //     { opacity: 0 },
    //     randomInterval,
    //     function () {
    //       $(".slider-item-overlay").animate(
    //         { opacity: 0.4 },
    //         randomInterval,
    //         function () {
    //           toggleOpacity(); // アニメーションが終わったら再度実行する
    //         }
    //       );
    //     }
    //   );
    // }

}
